var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useState, } from "react";
import VTButton from "../components/VTButton";
export function withForm(InputFieldsComponent) {
    return function VTForm(_a) {
        var sx = _a.sx, title = _a.title, titleAlign = _a.titleAlign, FormButtonsContainer = _a.FormButtonsContainer, inputFieldsProps = _a.inputFieldsProps, onSubmit = _a.onSubmit;
        var _b = __read(useState(null), 2), formInput = _b[0], setFormInput = _b[1];
        return (_jsx(Box, __assign({ component: "div", sx: __assign({}, sx) }, { children: _jsxs("form", __assign({ onSubmit: function (e) {
                    e.preventDefault();
                    onSubmit && onSubmit(formInput);
                } }, { children: [_jsx(Typography, __assign({ align: titleAlign, variant: "h5" }, { children: title })), _jsx(InputFieldsComponent, { setFormData: setFormInput, inputFieldsProps: inputFieldsProps }), _jsx(FormButtonsContainer, { vtFormDatanputObj: formInput })] })) })));
    };
}
function PrimarySecondaryButtons(_a) {
    var primaryButtonText = _a.primaryButtonText, secondaryAction = _a.secondaryAction;
    return (_jsxs(Box, __assign({ component: "div", sx: { display: "flex", width: "100%", marginTop: "8px" } }, { children: [_jsx(VTButton, __assign({ onSubmitButtonType: true, sx: {
                    flex: 1,
                    marginRight: "4px",
                }, color: "primary" }, { children: primaryButtonText })), _jsx(VTButton, __assign({ onClick: function (e) {
                    // e.preventDefault();
                    secondaryAction.onClick();
                }, sx: {
                    flex: 1,
                    marginLeft: "4px",
                }, color: "secondary" }, { children: secondaryAction.buttonText }))] })));
}
function getJustifyContentValueFromButtonAlign(singleButtonAlign) {
    if (singleButtonAlign === "left")
        return "start";
    if (singleButtonAlign === "right")
        return "end";
    if (singleButtonAlign === "center")
        return "center";
    throw new Error("singleButtonAlign type value not recognised");
}
function SingleButton(_a) {
    var buttonText = _a.buttonText, _b = _a.singleButtonAlign, singleButtonAlign = _b === void 0 ? "right" : _b;
    return (_jsx(Box, __assign({ component: "div", sx: {
            display: "flex",
            width: "100%",
            marginTop: "20px",
            justifyContent: getJustifyContentValueFromButtonAlign(singleButtonAlign),
        } }, { children: _jsx(VTButton, __assign({ onSubmitButtonType: true, sx: {
                width: { sm: "225px", lg: "250px" },
            }, color: "primary" }, { children: buttonText })) })));
}
export function WithFormWithPrimarySecondaryButtons(Form) {
    function VTFormWithPrimarySecondaryButtons(_a) {
        var sx = _a.sx, onSecondaryButtonClicked = _a.onSecondaryButtonClicked, primaryButtonText = _a.primaryButtonText, secondaryButtonText = _a.secondaryButtonText, title = _a.title, titleAlign = _a.titleAlign, inputFieldsProps = _a.inputFieldsProps, onSubmit = _a.onSubmit, loadingSpinner = _a.loadingSpinner;
        return (_jsx(Form, { sx: sx, inputFieldsProps: inputFieldsProps, title: title, titleAlign: titleAlign || "center", onSubmit: function (formFieldsStateObject) {
                onSubmit && onSubmit(formFieldsStateObject);
            }, FormButtonsContainer: function (_a) {
                var vtFormDatanputObj = _a.vtFormDatanputObj;
                return !loadingSpinner ? (_jsx(PrimarySecondaryButtons, { primaryButtonText: primaryButtonText, secondaryAction: {
                        buttonText: secondaryButtonText,
                        onClick: function () {
                            onSecondaryButtonClicked(vtFormDatanputObj);
                        },
                    } })) : (_jsx(Box, __assign({ component: "div", sx: { alignItems: "center", justifyContent: "center", display: "flex" } }, { children: _jsx(CircularProgress, {}) })));
            } }));
    }
    return VTFormWithPrimarySecondaryButtons;
}
export function WithFormWithSingleButton(Form) {
    function VTFormWithSingleButton(_a) {
        var sx = _a.sx, buttonText = _a.buttonText, onButtonClick = _a.onButtonClick, title = _a.title, titleAlign = _a.titleAlign, inputFieldsProps = _a.inputFieldsProps, singleButtonAlign = _a.singleButtonAlign, onSubmit = _a.onSubmit;
        return (_jsx(Form, { sx: sx, inputFieldsProps: inputFieldsProps, title: title, titleAlign: titleAlign || "center", onSubmit: function (formFieldsStateObject) {
                onSubmit && onSubmit(formFieldsStateObject);
            }, FormButtonsContainer: function (_a) {
                var vtFormDatanputObj = _a.vtFormDatanputObj;
                return (_jsx(SingleButton, { buttonText: buttonText, singleButtonAlign: singleButtonAlign, onButtonClick: function () { return onButtonClick(vtFormDatanputObj); } }));
            } }));
    }
    return VTFormWithSingleButton;
}
